import script from "./productSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./productSlider.vue?vue&type=script&setup=true&lang=js"

import "./productSlider.vue?vue&type=style&index=0&id=f5ee8ba8&lang=css"

const __exports__ = script;

export default __exports__